import React, { useState } from 'react';
import { Card, TextInput, Select, SelectItem, Button, Switch } from '@tremor/react';

export function OrganizationSettingsPage() {
  const [formData, setFormData] = useState({
    organizationName: '',
    contactEmail: '',
    address: '',
    phone: '',
    timeZone: 'UTC',
    currency: 'USD',
    language: 'en',
    maintenanceMode: false
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement save functionality
    console.log('Saving organization settings:', formData);
  };

  return (
    <div className="space-y-6">
      <Card>
        <h2 className="text-xl font-semibold mb-4">Brand / Organization Info</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Organization Name</label>
            <TextInput
              value={formData.organizationName}
              onChange={e => handleInputChange('organizationName', e.target.value)}
              placeholder="Enter organization name"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Contact Email</label>
            <TextInput
              type="email"
              value={formData.contactEmail}
              onChange={e => handleInputChange('contactEmail', e.target.value)}
              placeholder="Enter contact email"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Address</label>
            <TextInput
              value={formData.address}
              onChange={e => handleInputChange('address', e.target.value)}
              placeholder="Enter organization address"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Phone (Optional)</label>
            <TextInput
              type="tel"
              value={formData.phone}
              onChange={e => handleInputChange('phone', e.target.value)}
              placeholder="Enter phone number"
            />
          </div>
        </form>
      </Card>

      <Card>
        <h2 className="text-xl font-semibold mb-4">Regional Settings</h2>
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Time Zone</label>
            <Select
              value={formData.timeZone}
              onValueChange={value => handleInputChange('timeZone', value)}
            >
              <SelectItem value="UTC">UTC</SelectItem>
              <SelectItem value="America/New_York">Eastern Time</SelectItem>
              <SelectItem value="America/Chicago">Central Time</SelectItem>
              <SelectItem value="America/Denver">Mountain Time</SelectItem>
              <SelectItem value="America/Los_Angeles">Pacific Time</SelectItem>
            </Select>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Currency</label>
            <Select
              value={formData.currency}
              onValueChange={value => handleInputChange('currency', value)}
            >
              <SelectItem value="USD">USD ($)</SelectItem>
              <SelectItem value="EUR">EUR (€)</SelectItem>
              <SelectItem value="GBP">GBP (£)</SelectItem>
              <SelectItem value="JPY">JPY (¥)</SelectItem>
            </Select>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Language</label>
            <Select
              value={formData.language}
              onValueChange={value => handleInputChange('language', value)}
            >
              <SelectItem value="en">English</SelectItem>
              <SelectItem value="es">Spanish</SelectItem>
              <SelectItem value="fr">French</SelectItem>
              <SelectItem value="de">German</SelectItem>
            </Select>
          </div>
        </div>
      </Card>

      <Card>
        <h2 className="text-xl font-semibold mb-4">Maintenance Mode</h2>
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">Enable Maintenance Mode</p>
            <p className="text-sm text-gray-500">Temporarily disable user-facing experiences</p>
          </div>
          <Switch
            checked={formData.maintenanceMode}
            onChange={value => handleInputChange('maintenanceMode', value)}
          />
        </div>
      </Card>

      <div className="flex justify-end space-x-4">
        <Button variant="secondary">Cancel</Button>
        <Button onClick={handleSubmit}>Save Changes</Button>
      </div>
    </div>
  );
} 